export default __webpack_public_path__ + "images/6a8e65d142d8455f384cf90f4dd2bf7d.png";